import axios from "axios";

import { axiosClient } from "../../URLConfig";
import { AppContext } from "../../AppContext";
let abortControllers = {};

export async function GetProjectDetailsByFilter(
  searchInput,
  pageNumber,
  pageSize,
  eventtype,
  participantId,
  AdvancedEventTypes,
  ActiveSecondaryTabSkill,
  EventId,
  FiscalYear
) {
  let response;
  try {
    // console.log("AdvancedEventTypes", AdvancedEventTypes);
    if (
      "GetProjectDetailsByFilter" in abortControllers &&
      abortControllers["GetProjectDetailsByFilter"]
    ) {
      abortControllers["GetProjectDetailsByFilter"].abort();
    }
    // const payload = {
    //   SearchText: searchInput,
    //   PageNumber: PageNumber,
    //   PageSize:PageSize,
    //   eventtype:eventtype,

    // };

    abortControllers["GetProjectDetailsByFilter"] = new AbortController();

    response = await axiosClient.get(
      "ProjectDetails/GetProjectDetailsByFilter",
      {
        params: {
          SearchText: searchInput,
          PageNumber: pageNumber,
          PageSize: pageSize,
          AdvancedEventTypes: AdvancedEventTypes,

          eventtype: eventtype,
          ParticipantId: participantId,
          AdvancedEventTypesSkill: ActiveSecondaryTabSkill,
          EventId: EventId,
          FiscalYear: FiscalYear,
        },
        signal: abortControllers["GetProjectDetailsByFilter"].signal,
      }
    );
    delete abortControllers["GetProjectDetailsByFilter"];

    return response;
  } catch (error) {
    console.log(error);
  }
}
export async function GetOrganizerProjectDetailsByFilter(
  searchInput,
  pageNumber,
  pageSize,
  eventtype,
  participantId,
  userId,
  AdvancedEventTypes,
  ActiveSecondaryTabSkill,
  EventId,
  FiscalYear
) {
  let response;
  try {
    console.log("AdvancedEventTypes", AdvancedEventTypes);
    if (
      "GetOrganizerProjectDetailsByFilter" in abortControllers &&
      abortControllers["GetOrganizerProjectDetailsByFilter"]
    ) {
      abortControllers["GetOrganizerProjectDetailsByFilter"].abort();
    }

    abortControllers["GetOrganizerProjectDetailsByFilter"] =
      new AbortController();
    // const payload = {
    //   SearchText: searchInput,
    //   PageNumber: PageNumber,
    //   PageSize:PageSize,
    //   eventtype:eventtype,

    // };

    response = await axiosClient.get(
      "ProjectDetails/GetOrganizerProjectDetailsByFilter",
      {
        params: {
          SearchText: searchInput,
          PageNumber: pageNumber,
          PageSize: pageSize,
          AdvancedEventTypes: AdvancedEventTypes,
          eventtype: eventtype,
          ParticipantId: participantId,

          AdvancedEventTypesSkill: ActiveSecondaryTabSkill,
          userId: userId,
          EventId: EventId,
          FiscalYear: FiscalYear,
        },
        signal: abortControllers["GetOrganizerProjectDetailsByFilter"].signal,
      }
    );
    delete abortControllers["GetOrganizerProjectDetailsByFilter"];

    return response;
  } catch (error) {
    console.log(error);
  }
}

export const getProjectDetailsById = async (id, participantid, EventId) => {
  try {
    const response = await axiosClient.get(
      `ProjectDetails/GetTopicDetails/${id}/${EventId}/${participantid}/`
    );
    // ${JSON.parse(data.CurrentEvent).id}
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getURL_GetUserLoginTime = async () => {
  try {
    const response = await axiosClient.get(
      `GetUserLoginTime`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const UploadMultipleFiles = async (Files, folderType) => {
  console.log("UploadMultipleFiles", Files);
  const formData = new FormData();
  Files.forEach((item) => {
    formData.append("file", item.file);
    formData.append("folderType", folderType);
  });

  // formData.append("type", type);
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  let response;
  try {
    response = await axiosClient.post(
      "Upload/UploadMuplitpleFiletoBlob",
      formData
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const UploadFiles = async (file, type) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("type", type);
  let response;
  try {
    response = await axiosClient.post("Upload", formData);
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const getRecentProjects = async (projectid, participantid) => {
  console.log("participantid", participantid);
  console.log("projectid", projectid);
  try {
    const response = await axiosClient.get(
      `GetsubmittedProjectParticipant/${(projectid, participantid)}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const getSkills = async () => {
  try {
    console.log("getSkills api called");
    const response = await axiosClient.get(`Account/GetSkills`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const RegisterParticipantDetails = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post("Account/Register", Payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const uploadParticipantCv = async (payload) => {
  try {
    const { data } = await axiosClient.post('Account/UploadCv', payload);
    return { success: true, data };
  } catch (error) {
    console.error('CV upload failed:', error);
    return {
      success: false,
      message: error.response?.data || 'Something went wrong',
      status: error.response?.status || 500,
    };
  }
};



export const SaveParticipantSkills = async (payload) => {
  try {
    const response = await axiosClient.post("Account/AddParticipantSkills", payload);
    return response;
  } catch (error) {
    console.error("Error in SaveParticipantSkills:", error);
    throw error;
  }
};

export const ParticipantSignIn = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post("Account/Login", Payload);
    console.log(response)
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    }
    console.log(error);
  }
};
export const EnrollProjectByParticipnatId = async (
  participantId,
  projectId,
  status
) => {
  let response;
  try {
    response = await axiosClient.post(
      `ProjectDetails/AddUpdateProjectParticipant?participantId=${participantId}&projectId=${projectId}&status=${status}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const ProjectSubmissionDetails = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post(
      "ProjectDetails/AddParticipantDetailsOnSubmit",
      Payload
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const UpdateSubmissionAcceptance = async (submissionId, isAccepted, updatedBy, rejectionReason) => {
  let response;
  try {
    response = await axiosClient.post("ProjectDetails/UpdateSubmissionAcceptance", {
      submissionId,
      isAccepted,
      updatedBy,
      rejectionReason,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getProfilePicture = async (userid) => {
  let response;
  try {
    response = await axiosClient.get(`Upload/GetProfileImage/${userid}`, {});
    return response;
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getlogobanner = async (projectId, type) => {
  let response;
  try {
    response = await axiosClient.get(
      `Upload/GetLogoBanner/${projectId}/${type}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const exportRules = async (projectId) => {
  let response;
  try {
    response = await axiosClient.get(`Upload/ExportRules/${projectId}`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const GetUserCV = async (userid) => {
  let response;
  try {
    response = await axiosClient.get(`Upload/GetUserCV/${userid}`, {
      responseType: "blob",
      transformResponse: [
        function (data) {
          let blob = new window.Blob([data], { type: "application/pdf" });
          return window.URL.createObjectURL(blob);
        },
      ],
    });
    // return response;
    console.log("Get User CV Response", response);
  } catch (error) {
    console.log(error);
  }
  return response;
};
// export const GetDownloadFile = async (azurepath) => {

//   const formData = new FormData();
//   formData.append("azurepath", azurepath);
// let response;
// try {
//   response = await axiosClient.post("Upload/DownloadFile", formData, {

//     responseType: "blob",

//   });
//   return response;
// } catch (error) {
//   console.log(error);
// }
// }
export const GetParticipantProfileData = async (
  searchInput,
  pageNumber,
  pageSize,
  userid
) => {
  let response;
  try {
    if (
      "GetParticipantProfileData" in abortControllers &&
      abortControllers["GetParticipantProfileData"]
    ) {
      abortControllers["GetParticipantProfileData"].abort();
    }

    abortControllers["GetParticipantProfileData"] = new AbortController();

    response = await axiosClient.get(
      `ProjectDetails/GetParticipantProfileData/${userid}`,
      {
        params: {
          SearchText: searchInput,
          PageNumber: pageNumber,
          PageSize: pageSize,
        },
        signal: abortControllers["GetParticipantProfileData"].signal,
      }
    );
    delete abortControllers["GetParticipantProfileData"];
    return response;
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const GetRecentTopics = async (eventId) => {
  let response;
  try {
    response = await axiosClient.get(`ProjectDetails/GetRecentTopics`, {
      params: {
        EventId: eventId,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const GetHackathonEvents = async (eventId) => {
  let response;
  try {
    response = await axiosClient.get(`ProjectDetails/GetHackathonEvents`, {
      params: {
        EventId: eventId,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const GetDefaultPrizes = async () => {
  let response;
  try {
    response = await axiosClient.get(`ProjectDetails/GetPoints`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const AddTopic = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post("ProjectDetails/AddTopic", Payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const AddSession = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post("ProjectDetails/AddSession", Payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const UpdateTopic = async (Id, Payload) => {
  let response;
  try {
    response = await axiosClient.post(
      `ProjectDetails/UpdateTopic/${Id}`,
      Payload
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const UpdateSession = async (Id, Payload) => {
  let response;
  try {
    response = await axiosClient.post(
      `ProjectDetails/UpdateSession/${Id}`,
      Payload
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const AddEditPrizes = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post(
      "ProjectDetails/AddEditProjectPrizes",
      Payload
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const AddEditTimeline = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post(
      "ProjectDetails/AddEditProjectTimeline",
      Payload
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const AddEditJury = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post(
      "ProjectDetails/AddEditProjectJuries",
      Payload
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const AddEditMentor = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post(
      "ProjectDetails/AddEditProjectMentors",
      Payload
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const DeleteTopic = async (Id) => {
  let response;
  try {
    response = await axiosClient.post(`ProjectDetails/DeleteTopic/${Id}`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const AddEditRules = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post(
      "ProjectDetails/AddEditProjectRules",
      Payload
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getSortedData = async (
  pageNumber,
  pageSize,
  userid,
  colName,
  order
) => {
  let response;
  try {
    response = await axiosClient.get(
      `ProjectDetails/GetSortedParticipantProfileData/${userid}/${colName}/${order}`,
      {
        params: {
          PageNumber: pageNumber,
          PageSize: pageSize,
        },
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
  return response;
};

 export const getUnavailableParticipants = async (projectId) => {
    try {
      const response = await axiosClient.get(`ProjectDetails/GetSubmittedParticipantDetails/${projectId}`
      );

      return response;
    
    } catch (err) {
      console.error("Failed to fetch unavailable participants", err);
     
    } 
 
  };
  


export const loadOptions = async (searchInput, pageNumber, pageSize) => {
  let response,response1;
  try {
    if ("loadOptions" in abortControllers && abortControllers["loadOptions"]) {
      abortControllers["loadOptions"].abort();
    }

    abortControllers["loadOptions"] = new AbortController();
//Admin/Get
     response = await axiosClient.get(`Users`, {
      params: {
        SearchText: searchInput,
        PageNumber: pageNumber,
        PageSize: pageSize,
      },
      signal: abortControllers["loadOptions"].signal,
    });
    delete abortControllers["GetParticipantProfileData"];
    
    console.log("load page reponse in register project ",response)
    return response;

    
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const GetUsersList = async (searchInput, pageNumber, pageSize) => {
  let response;
  try {
    if (
      "GetUsersList" in abortControllers &&
      abortControllers["GetUsersList"]
    ) {
      abortControllers["GetUsersList"].abort();
    }

    abortControllers["GetUsersList"] = new AbortController();

    response = await axiosClient.get(`/Admin/GetUsers`, {
      params: {
        SearchText: searchInput,
        PageNumber: pageNumber,
        PageSize: pageSize,
      },
      signal: abortControllers["GetUsersList"].signal,
    });
    delete abortControllers["GetUsersList"];

    return response;
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const GetRolesList = async (searchInput, pageNumber, pageSize) => {
  let response;
  try {
    if (
      "GetRolesList" in abortControllers &&
      abortControllers["GetRolesList"]
    ) {
      abortControllers["GetRolesList"].abort();
    }

    abortControllers["GetRolesList"] = new AbortController();

    response = await axiosClient.get(`/Admin/GetRoles`, {
      params: {
        SearchText: searchInput,
        PageNumber: pageNumber,
        PageSize: pageSize,
      },
      signal: abortControllers["GetRolesList"].signal,
    });
    delete abortControllers["GetParticipantProfileData"];

    return response;
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const AddEditUsers = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post("Admin/AddEditDeleteUsers", Payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const GetAchivementsCount = async (EventId) => {
  let response;
  try {
    response = await axiosClient.get(`Account/GetAchivementsCount/${EventId}`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const AddEditDeleteRole = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post("admin/AddEditDeleteRole", Payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const UserTracker = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post("UserTracking", Payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const saveJuryPoints = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post("ProjectDetails/AddJuryPoints", Payload);
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const GetDownloadFile = async (azurepath) => {
  const formData = new FormData();
  formData.append("azurepath", azurepath);
  let response;
  try {
    response = await axiosClient.post("Upload/DownloadFile", formData, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const saveWinnersList = async (Payload, selections) => {
  let response;
  try {
    response = await axiosClient.post(
      `ProjectDetails/PublishWinners?projectId=${Payload}`,
      selections
    );
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
export const GetSubmittedDetails = async (ProjectId, ParticipantId) => {
  let response;
  try {
    response = await axiosClient.get(
      // "ProjectDetails/GetSubmittedDetails"${(projectid, participantid)},
      `ProjectDetails/GetSubmittedDetails/${ProjectId}/${ParticipantId}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const GetSubmittedParticipantsDetails = async (ProjectId) => {
  let response;
  try {
    response = await axiosClient.get(
      // "ProjectDetails/GetSubmittedDetails"${(projectid, participantid)},
      `ProjectDetails/GetSubmittedParticipantDetails/${ProjectId}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getActionItems = async (
  searchInput,
  pageNumber,
  pageSize,
  participantId
) => {
  let response;
  try {
    if (
      "getActionItems" in abortControllers &&
      abortControllers["getActionItems"]
    ) {
      abortControllers["getActionItems"].abort();
    }
    abortControllers["getActionItems"] = new AbortController();

    response = await axiosClient.get(
      `/ProjectDetails/getActionItems/${participantId}`,
      {
        params: {
          SearchText: searchInput,
          PageNumber: pageNumber,
          PageSize: pageSize,
        },
        signal: abortControllers["getActionItems"].signal,
      }
    );
    delete abortControllers["getActionItems"];

    return response;
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const editProfilePicture = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post(
      "ProjectDetails/AddEditProfilePhoto",
      Payload
    );
    return response;
  } catch (error) {
    console.log("error editProfilePicture", error);
  }
};

export const GetUserCVPath = async (participantId) => {
  let response;
  try {
    response = await axiosClient.get(
      `ProjectDetails/GetParticipantCV/${participantId}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const markReadActionItem = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post(
      `ProjectDetails/MarkReadActionItem?actionItemId=${Payload}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getSortedActionData = async (
  pageNumber,
  pageSize,
  userid,
  colName,
  order
) => {
  let response;
  try {
    response = await axiosClient.get(
      `ProjectDetails/GetSortedActionItems/${userid}/${colName}/${order}`,
      {
        params: {
          PageNumber: pageNumber,
          PageSize: pageSize,
        },
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const uploadFeedback = async (payload) => {
  let response;
  try {
    response = await axiosClient.post("Feedback/AddFeedback", payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};

//#region groups
export const GetEvents = async (searchInput, pageNumber, pageSize) => {
  let response;
  try {
    if ("GetEvents" in abortControllers && abortControllers["GetEvents"]) {
      abortControllers["GetEvents"].abort();
    }

    abortControllers["GetEvents"] = new AbortController();

    response = await axiosClient.get(`/Admin/GetEvents`, {
      params: {
        SearchText: searchInput,
        PageNumber: pageNumber,
        PageSize: pageSize,
      },
      signal: abortControllers["GetEvents"].signal,
    });
    delete abortControllers["GetParticipantProfileData"];

    return response;
  } catch (error) {
    console.log(error);
  }
};
export const AddEditDeleteEvent = async (Payload) => {
  let response;
  try {
    response = await axiosClient.post("admin/AddEditDeleteEvent", Payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const GetAllEvents = async () => {
  let response;
  try {
    response = await axiosClient.get("admin/GetAllEvents");
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getProjectCategories = async () => {
  let response;
  try {
    response = await axiosClient.get("/ProjectDetails/GetProjectCategories")
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};


export const addProjectCategory = async (categoryLabel, createdBy) => {
  try {
    const payload = {
      category: categoryLabel,
      createdBy: createdBy,
    };

    const response = await axiosClient.post(
      "ProjectDetails/AddProjectCategory",
      payload
    );

    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};


export const addSkill = async (skillName, createdBy) => {
  try {
    const payload = {
      skill1: skillName,
      createdBy: createdBy,
    };

    const response = await axiosClient.post("ProjectDetails/AddSkill", payload);
    return response;
  } catch (error) {
    console.error("Error adding skill:", error);
    return error.response;
  }
};
